"use client";

import { useEffect } from "react";

export default function LegalNotice() {

  useEffect(() => {
      // Update page title
      document.title = "Legal Notice & Terms | Gemini Building Supply";
      
      // Update meta description
      let descriptionMeta = document.querySelector('meta[name="description"]');
      if (!descriptionMeta) {
        descriptionMeta = document.createElement('meta');
        descriptionMeta.setAttribute('name', 'description');
        document.head.appendChild(descriptionMeta);
      }
      descriptionMeta.setAttribute('content', "Review Gemini UAE’s legal notice, terms, and policies to understand user rights, responsibilities, and important compliance information.");
  
      // Update canonical URL
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', "https://geminiuae.com/legal-notice");
      
    },[]);

  return (
    <div>
      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto">
        <h2
          className="text-mob-38 sm:text-tab-38 lg:text-web-50 leading-mob-55 sm:leading-tab-55 lg:leading-[120%]
               text-SecondaryYellow tracking-wider font-normal lg:font-normal capitalize drop-shadow-sm text-center
               py-mob-46 sm:py-tab-40 lg:py-web-50 rounded-lg
               bg-[url('/images/header-text-wrapper-mob.webp')] sm:bg-[url('/images/header-text-wrapper.webp')]
               bg-cover bg-center"
        >
          Legal Notice
        </h2>
      </div>
      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[65.58vw] mx-auto py-mob-80 sm:py-tab-90 lg:py-[5.72vw]">
        <ul>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              In using this website you are assumed to have read and agreed to
              the following:
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              We are committed to protecting your privacy. By accessing the
              Company’s website, you acknowledge your agreement with and
              understanding of the following terms and conditions as
              hereinafter. We constantly review our systems and data to ensure
              the best possible service to our customers. We will investigate
              any such actions with a view to prosecuting and/or taking civil
              proceedings to recover damages against those responsible.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Any information concerning the Client and their respective Client
              Records may be passed to third parties. However, Client records
              are regarded as confidential and therefore will not be divulged to
              any third party, other than such officers and employees need to
              know such information, and such professional advisers or
              consultants engaged to advise the Company, and who, in each case,
              are advised of this Terms and Conditions and agree to keep such
              information confidential and to be bound by this Terms and
              Conditions to the same extent as if they were parties hereto. If
              legally required to do so to the appropriate authorities, it has
              been made publically available or is already or becomes legally
              and properly in the Company’s possession on a non-confidential
              basis from other sources.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              We will not sell, share, or rent your personal information to any
              third party or use your e-mail address for unsolicited mail. Any
              emails sent by this Company will only be in connection with the
              provision of agreed services and products.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              Disclaimer
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The information on this web site is provided on an “as is” basis.
              To the fullest extent permitted by law, this Company:
            </p>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Excludes all representations and warranties relating to this
              website and its contents or which is or may be provided by any
              affiliates or any other third party, including in relation to any
              inaccuracies or omissions in this website and/or the Company’s
              literature; and excludes all liability for damages arising out of
              or in connection with your use of this website. This includes,
              without limitation, direct loss, loss of business or profits
              (whether or not the loss of such profits was foreseeable, arose in
              the normal course of things or you have advised this Company of
              the possibility of such potential loss), damage caused to your
              computer, computer software, systems and programs and the data
              thereon or any other direct or indirect, consequential and
              incidental damages.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              Copyright and other relevant intellectual property rights exists
              on all text relating to the Company’s services and the full
              content of this website and shall prohibit its use, unless
              otherwise expressly authorized in written.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              This Company’s logo is a registered trademark of this Company in
              UAE and other countries. The brand names and specific services of
              this Company featured on this web site are trade marked.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              We have an e-mail address for any queries. These, & other contact
              information, can be found on our website or via Company literature
              or via the Company’s stated telephone, facsimile or mobile
              telephone numbers.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              GBM is registered in Dubai International Financial Centre
              regulated by Dubai Financial Services Authority – UAE.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The laws of the UAE and Dubai Financial Services Authority shall
              govern these terms and conditions and in all disputes arising out
              of such access. If any of these terms are deemed invalid or
              unenforceable for any reason (including, but not limited to the
              exclusions and limitations set out above), then the invalid or
              unenforceable provision will be severed from these terms and the
              remaining terms will continue to apply. Failure of the Company to
              enforce any of the provisions set out in these Terms and
              Conditions and any Agreement, or failure to exercise any option to
              terminate, shall not be construed as waiver of such provisions and
              shall not affect the validity of these Terms and Conditions or of
              any Agreement or any part thereof, or the right thereafter to
              enforce each and every provision. These Terms and Conditions shall
              not be amended, modified, varied or supplemented except in writing
              and signed by duly authorised representatives of the Company.
            </p>
          </li>
          <li className="mb-mob-38 sm:mb-tab-38 lg:mb-web-58">
            <h6 className="text-mob-18 sm:text-tab-18 lg:text-web-26 leading-[120%] font-medium text-TitleBlack capitalize mb-mob-20 sm:mb-tab-20 lg:mb-web-25">
              Notification of Changes
            </h6>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              The Company reserves the right to change these conditions from
              time to time as it sees fit. If there are any changes to our
              privacy policy, we will announce that these changes have been made
              on our home page and on other key pages on our site. You are
              therefore advised to re-read this statement on a regular basis.
            </p>
          </li>
          <li>
            <p className="text-mob-16 sm:text-tab-16 lg:text-web-20 leading-[186%]  text-[#6d6d6d] capitalize mb-mob-15 sm:mb-tab-15 lg:mb-web-20 last:mb-0">
              These terms and conditions form part of the Agreement between the
              Client and ourselves. Your access to this website and/or
              undertaking of a booking or Agreement indicates your
              understanding, agreement to and acceptance, of the Disclaimer
              Notice and the full Terms and Conditions contained herein.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}
